import React, { Component } from "react";
import Section from "./Section";

class SectionsContainer extends Component {
    state = {
        showGhowRow: false
    };
    render() {
        return (
            <div
                className="pageBuilder"
                style={{
                    width: "100%",
                    // height: "100%",
                    flexFlow: "column",
                    alignItems: "center",
                    zIndex: 0,
                    padding: "10px",
                    userSelect: "none"
                }}
                onDragOver={(e) => e.preventDefault()}
            >
                {this.props.sections.map((section, sectIndex) => {
                    const { sectionId, rowsInSection } = section;
                    return (
                        <Section
                            elDragData={this.props.elDragData}
                            key={sectionId}
                            sectionId={sectionId}
                            rowsInSection={rowsInSection}
                            showStructures={this.props.showStructures}
                            addGhostElementOnDragOver={(DropZone, otherArgs) =>
                                this.props.addGhostElementOnDragOver(
                                    DropZone,
                                    sectionId,
                                    otherArgs
                                )
                            }
                            removeGhostElementOnDragLeave={(
                                DropZone,
                                otherArgs
                            ) =>
                                this.props.removeGhostElementOnDragLeave(
                                    DropZone,
                                    sectionId,
                                    otherArgs
                                )
                            }
                            setElDragData={this.props.setElDragData}
                        />
                    );
                })}

                {/*
                {this.props.body.map((row) => {
                    // console.log(row);
                    const { isDynamic, rowElements, rowId } = row;
                    if (isDynamic) {
                        return (
                            <>
                                <DynamicRow
                                    style={{
                                        width: "98%",
                                        minHeight: 70,
                                        borderTop: "1px dashed black",
                                        borderBottom: "1px dashed black",
                                        display: "flex",
                                        position: "relative",
                                        zIndex: 1,
                                        userSelect: "none"
                                    }}
                                />
                            </>
                        );
                    }
                    return (
                        <SimpleRow
                            addnewItem={this.props.addnewItem}
                            changeElementWidth={this.props.changeElementWidth}
                            changeElementsWidthDragOver={
                                this.props.changeElementsWidthDragOver
                            }
                            rowElements={rowElements}
                            rowId={rowId}
                            style={{
                                width: "98%",
                                minHeight: 70,
                                display: "flex",
                                position: "relative",
                                zIndex: 1,
                                userSelect: "none",
                                marginTop: 5,
                                backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='%23333' stroke-width='2' stroke-dasharray='10%2c 10' stroke-dashoffset='53' stroke-linecap='square'/%3e%3c/svg%3e")`
                            }}
                            elDragData={this.props.elDragData}
                            setElDragData={this.props.setElDragData}
                        />
                    );
                })}

                <GhostRow
                    addnewItem={this.props.addnewItem}
                    setOpacityOne={() => this.setState({ showGhowRow: true })}
                    setOpacityZero={() => this.setState({ showGhowRow: false })}
                    showStructures={this.props.showStructures}
                    showGhowRow={this.state.showGhowRow}
                /> */}
            </div>
        );
    }
}

export default SectionsContainer;
